import { HttpClient } from '../../httpClient'
import { OpalApiRequestParams, OpalApiResponseDocument } from '../../schema'

type Params = Pick<
  OpalApiRequestParams<'NotifyBlockCustomFieldValueV3'>,
  'path'
>
type Response = OpalApiResponseDocument<'NotifyBlockCustomFieldValueV3', 200>

export const notifyBlockCustomFieldValue = ({ params }: { params: Params }) => {
  const url = new URL(
    `/loupe/v3/block_custom_field_values/${params.path.block_custom_field_value_id}/do/notify`,
    window.location.origin
  )

  return HttpClient()
    .post<Response>(url.toString(), {})
    .then((res) => res.data)
}
